<template>
  <nav class="d-flex w-100 flex-column sidebar-nav gap-3 mt-4">
    <!-- loading -->
    <span v-if="!items || items.length === 0">
      <a
        v-for="item in 25"
        :key="item"
        class="d-flex align-items-center gap-4 ch-sidebar-item"
        style="padding: 12px 12px 12px 15px"
      >
        <Skeleton style="width: 100%; height: 24px"></Skeleton>
      </a>
    </span>

    <div v-else v-for="(item, i) in items" :key="i">
      <router-link
        class="d-flex align-items-center gap-4 ch-sidebar-item"
        :class="{ 'justify-content-center': !menuActive }"
        :to="item.to"
        :target="item.target"
        @click="onClick(i)"
        style="padding: 12px"
        v-if="!item.items || item.items.length === 0"
      >
        <span style="width: 24px; height: 24px">
          <i v-if="item.icon" :class="['layout-menuitem-icon', item.icon]"></i>
          <div
            v-if="item.src"
            class="icon"
            :style="{
              '-webkit-mask': `url(/img/${item.src}) no-repeat center`,
              mask: `url(/img/${item.src}) no-repeat center`,
              'mask-size': 'contain',
              '-webkit-mask-size': 'contain',
            }"
          />
        </span>
        <span v-if="menuActive" class="ch-item-title">
          {{ item.label }}
        </span>
      </router-link>

      <a
        class="d-flex align-items-center gap-4 ch-sidebar-item"
        :class="{ 'justify-content-center': !menuActive }"
        :target="item.target"
        @click="onClick(i)"
        style="padding: 12px 12px 12px 15px"
        type="button"
        v-if="item.items && item.items.length > 0"
      >
        <span style="width: 24px; height: 24px">
          <i v-if="item.icon" :class="['layout-menuitem-icon', item.icon]"></i>
          <div
            v-if="item.src"
            class="icon"
            :style="{
              '-webkit-mask': `url(/img/${item.src}) no-repeat center`,
              mask: `url(/img/${item.src}) no-repeat center`,
              'mask-size': 'contain',
              '-webkit-mask-size': 'contain',
            }"
          />
        </span>
        <span v-if="menuActive" class="ch-item-title">
          {{ item.label }}
        </span>
        <i
          v-if="menuActive"
          class="layout-inline-menu-icon pi pi-chevron-right"
          :style="getStyleObject(i)"
        ></i>
      </a>

      <!-- Sub menu -->
      <transition v-if="item.items && item.items.length > 0">
        <div v-show="activeIndex === i" class="ch-sub-menu">
          <div
            v-for="(subItem, index) in item.items"
            :key="index"
            :style="[!menuActive ? { paddingLeft: 0 } : '']"
          >
            <router-link
              class="d-flex align-items-center gap-4 ch-sidebar-item"
              :class="{ 'justify-content-center': !menuActive }"
              :to="subItem.to"
              :target="subItem.target"
              @click="onClick(index)"
              style="padding: 6px 6px 6px 12px"
            >
              <span style="width: 24px; height: 24px">
                <i
                  v-if="subItem.icon"
                  :class="['layout-menuitem-icon', subItem.icon]"
                ></i>
                <div
                  v-if="subItem.src"
                  class="icon"
                  :style="{
                    '-webkit-mask': `url(/img/${subItem.src}) no-repeat center`,
                    mask: `url(/img/${subItem.src}) no-repeat center`,
                    'mask-size': 'contain',
                    '-webkit-mask-size': 'contain',
                  }"
                />
              </span>
              <span v-if="menuActive" class="ch-item-title">
                {{ subItem.label }}
              </span>
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </nav>
</template>

<style scoped lang="scss">
.icon {
  width: 24px;
  height: 24px;
  background-color: #42526e;
}
.sidebar-nav {
  overflow-y: auto;
  padding: 0 12px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  .layout-inline-menu-icon {
    font-size: 12px;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border: 0;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  .ch-sidebar-item {
    position: relative;
    border-radius: 5px;
    transition: 0.3s;
    color: #42526e;
    font-family: Jost;
    font-size: 14px;
    font-weight: 600;
    width: 100%;
    text-decoration: none;
    cursor: pointer;

    .ch-item-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
      flex: 1;
      min-width: 0;
    }

    &:hover,
    &.router-link-active {
      background-color: #e6effc;
      text-decoration: none;
    }

    &.router-link-active {
      .icon {
        background-color: #015cac;
      }

      .ch-item-title {
        color: #015cac;
      }
    }

    &.router-link-active::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 5px;
      height: 24px;
      border-radius: 0 2px 2px 0;
      background: #015cac;
    }
  }
  .ch-sub-menu:not(.ch-sidebar-item) {
    padding-left: 20px;
    width: 100%;
    box-sizing: border-box;
  }

  .ch-sub-menu .ch-sidebar-item {
    color: #53678b;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    padding-left: 20px;
  }
}

.gap-3 {
  gap: 8px;
}

.gap-4 {
  gap: 16px;
}

.v-enter-active {
  transition: opacity 200ms ease-in-out;
}

.v-enter-from {
  opacity: 0;
}

@media (max-width: 576px) {
  .sidebar-nav {
    padding: 0 8px;
    
    .ch-sidebar-item {
      font-size: 14px;
      padding: 10px 8px !important;
    }
    
    .ch-sub-menu:not(.ch-sidebar-item) {
      padding-left: 10px;
    }
    
    .ch-sub-menu .ch-sidebar-item {
      padding-left: 10px;
    }
  }
  
  /* Prevent text overflow */
  .ch-item-title {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  /* Better icon alignment */
  .layout-inline-menu-icon {
    margin-left: auto;
  }
}
</style>

<script>
import { getItem } from './store/localStorage'
import { mapState } from 'vuex'

export default {
  name: 'AppSubMenu',
  emits: ['menuitem-click', 'root-menuitem-click', 'change-appmenu'],
  props: {
    activeMenu: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    items: Array,
    root: {
      type: Boolean,
      default: true,
    },
    menuActive: {
      type: Boolean,
      default: true,
    },
    parentMenuItemActive: {
      type: Boolean,
      default: false,
    },
    menuMode: String,
    mobileMenuActive: Boolean,
    isSlimOrHorItemClick: Boolean,
    inlineMenuKey: String,
    mobileWidth: Boolean,
  },
  data() {
    return {
      rights: JSON.parse(getItem('rights')),
      activeIndex: null,
      hoverMenuActive: false,
      activeClass: false,
      activeSubmenu: '',
    }
  },
  methods: {
    getStyleObject(index) {
      return {
        transform:
          this.activeIndex !== index ? 'rotate(0deg)' : 'rotate(90deg)',
        transition: 'all 250ms ease-in-out',
      }
    },
    onClick(key) {
      this.activeIndex = this.activeIndex === key ? null : key
    },
    isAuthority(auth_code) {
      if (!auth_code || !this.rights) return false
      return this.rights.some((row) => auth_code.includes(row.link))
    },
    visible(item) {
      return (
        this.isAuthority(item.auth_code) ||
        (typeof item.visible === 'function'
          ? item.visible()
          : item.visible !== false)
      )
    },
  },
  computed: {
    isRTL() {
      return this.$appState.RTL
    },
    ...mapState({
      account: (state) => state.account,
    }),
  },
}
</script>
